import Vue from "vue";
import $ from "jquery";
import Component from "vue-class-component";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component
export default class modalEditionFinDeMoisCumulees extends Vue {
	public moisDebut = 0;
	public anneeDebut = 0;
	public moisFin = 0;
	public anneeFin = 0;
	public isLoading = false;

    public init(): void {
        $("#modalEditionFinDeMoisCumulees").modal("show");
        this.isLoading = true;
    	ServicesFactoryInstance.ExercicesService.getDernierExercice(data => {
    		this.anneeDebut = this.anneeFin = data.Annee;
            this.moisDebut = this.moisFin = data.Mois;
            this.isLoading = false;
        }, () => {
            this.isLoading = false;
        });
	}

	public annuler(): void {
    	$("#modalEditionFinDeMoisCumulees").modal("hide");
	}

	public valider(): void {
    	const dateDebut = new Date(this.anneeDebut, this.moisDebut - 1);
    	const dateFin = new Date(this.anneeFin, this.moisFin - 1);

    	if (dateDebut > dateFin) {
    		NotificationServiceInstance.SendFailed("La date de fin doit être supérieur à la date de début");

    		return;
    	}

    	this.editionFinDeMoisCumulees();
	}

    public editionFinDeMoisCumulees() {
        NotificationServiceInstance.SendInformation("Les éditions cumulées seront bientôt disponibles. Cela peut prendre quelques minutes.");
    	ServicesFactoryInstance.EditionsService.editionFinDeMoisCumuleesByAnneeEtMoisExercices(
    		this.anneeDebut, this.moisDebut,
    		this.anneeFin, this.moisFin);
        this.annuler();
	}
}




// WEBPACK FOOTER //
// ./src/components/modalComponents/modalEditionFinDeMoisCumulees/modalEditionFinDeMoisCumulees.ts